
const UNSAFE_SEGMENT_PATTERN = /(\.\.|\/|\\|%2f|%5c|%2e%2e)/i

const toSafePathSegment = value => {
  const raw = String(value ?? '').trim()

  if (!raw || UNSAFE_SEGMENT_PATTERN.test(raw)) {
    throw new Error(`Unsafe path segment: ${raw}`)
  }

  return encodeURIComponent(raw)
}

export const PRODUCT_OVERVIEW_CONFIG = {
  PRODUCT_TARGETS: id => ({
    endPoint: `product/${toSafePathSegment(id)}`,
    // mockData: productOverviewData,
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
  }),
}
  